import { useEffect, useRef } from "react";

export const VW = 1280;

const palette = (() => {
  const c = document.createElement("canvas");
  c.width = 256; c.height = 1;
  const g = c.getContext("2d"), grd = g.createLinearGradient(0, 0, 256, 0);
  [[0, "#0000ff"], [0.35, "#00ffff"], [0.55, "#00ff00"], [0.75, "#ffff00"], [1, "#ff0000"]].forEach(([o, col]) => grd.addColorStop(o, col));
  g.fillStyle = grd; g.fillRect(0, 0, 256, 1);
  return g.getImageData(0, 0, 256, 1).data;
})();

const drawPoints = (ctx, pts, h, radius) => {
  const max = Math.max(1, ...pts.map((p) => p[2]));
  pts.forEach(([x, y, n]) => {
    const px = (x / 100) * VW, g = ctx.createRadialGradient(px, y, 0, px, y, radius);
    g.addColorStop(0, `rgba(0,0,0,${Math.min(1, 0.15 + n / max)})`); g.addColorStop(1, "rgba(0,0,0,0)");
    ctx.fillStyle = g; ctx.fillRect(px - radius, y - radius, radius * 2, radius * 2);
  });
  const img = ctx.getImageData(0, 0, VW, h), d = img.data;
  for (let i = 0; i < d.length; i += 4) {
    const a = d[i + 3];
    if (!a) continue;
    d[i] = palette[a * 4]; d[i + 1] = palette[a * 4 + 1]; d[i + 2] = palette[a * 4 + 2]; d[i + 3] = Math.min(230, a * 1.4);
  }
  ctx.putImageData(img, 0, 0);
};

const drawScroll = (ctx, rows, h) => {
  rows.slice(0, 10).forEach((r, i) => {
    const y0 = (h * i) / 10, pct = r.pct / 100;
    ctx.fillStyle = `rgba(${Math.round(255 * (1 - pct))},${Math.round(80 + 140 * pct)},60,0.45)`;
    ctx.fillRect(0, y0, VW, h / 10);
    ctx.fillStyle = "#fff"; ctx.font = "bold 22px sans-serif";
    ctx.fillText(`${r.depth}% · ${r.pct}% visitatori`, 20, y0 + 34);
  });
};

export const HeatCanvas = ({ data, kind, height, canvasRef }) => {
  const local = useRef(null);
  const ref = canvasRef || local;
  useEffect(() => {
    const c = ref.current;
    if (!c || !data) return;
    c.width = VW; c.height = height;
    const ctx = c.getContext("2d", { willReadFrequently: true });
    ctx.clearRect(0, 0, VW, height);
    if (kind === "scroll") drawScroll(ctx, data.scroll, height);
    else drawPoints(ctx, kind === "click" ? data.clicks : data.moves, height, kind === "click" ? 28 : 18);
  }, [data, kind, height, ref]);
  return <canvas ref={ref} data-testid="hm-canvas" className="absolute inset-0 w-full h-full pointer-events-none" />;
};
